import { workPsnlworkProxy } from './index';
// proxy/work/psnlwork/

/* [ 일정 ] */
// 개인별일정 목록조회
function getPsnlCalendarMonList(params) {
  return workPsnlworkProxy.get('calendar/1.0/month/list', { params });
}

export { getPsnlCalendarMonList };
